import React, { useEffect, useState } from 'react';
import { billingAPI } from '../services/api';

// Founder, 24 Oct 2026: a VisionExploit-fee payment marked Received issues its
// billing receipt in the same step, so it must name the invoice it pays — or
// say why it isn't for one. Pre-selects the client's only open invoice.
export const NOT_FOR_INVOICE = 'none';

export default function InvoicePick({ studentId, currency, value, onChange, inputStyle }) {
  const [invoices, setInvoices] = useState(null);

  useEffect(() => {
    if (!studentId) return;
    billingAPI.receipts.openInvoices(studentId, currency || undefined)
      .then((r) => {
        const rows = r.data?.results || [];
        setInvoices(rows);
        if (!value.invoice) {
          onChange({ ...value, invoice: rows.length === 1 ? String(rows[0].id) : (rows.length ? '' : NOT_FOR_INVOICE) });
        }
      })
      .catch(() => setInvoices([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId, currency]);

  if (invoices === null) return <span style={{ fontSize: 11, opacity: 0.7 }}>Loading invoices…</span>;
  return (
    <>
      <select style={inputStyle} value={value.invoice} required
        onChange={(e) => onChange({ ...value, invoice: e.target.value })}>
        <option value="">Which invoice does this pay?</option>
        {invoices.map((inv) => (
          <option key={inv.id} value={inv.id}>
            {inv.number} — {inv.currency} {Number(inv.balance).toFixed(2)} left{inv.subject ? ` · ${inv.subject.slice(0, 40)}` : ''}
          </option>
        ))}
        <option value={NOT_FOR_INVOICE}>Not for an invoice</option>
      </select>
      {value.invoice === NOT_FOR_INVOICE && (
        <input style={inputStyle} placeholder="Why? e.g. Advance / credit on account" value={value.reason || ''}
          onChange={(e) => onChange({ ...value, reason: e.target.value })} required />
      )}
    </>
  );
}

// The request fields the server expects from an InvoicePick value.
export const invoicePickPayload = (v) => (
  v.invoice === NOT_FOR_INVOICE ? { not_for_invoice_reason: (v.reason || '').trim() } : { invoice: v.invoice }
);

export const invoicePickReady = (v) => (
  v.invoice === NOT_FOR_INVOICE ? Boolean((v.reason || '').trim()) : Boolean(v.invoice)
);
